import { useState } from 'react'
import { LogIn, Loader } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export function LoginButton() {
  const { login, isLoading, error } = useAuth()
  const [isSigningIn, setIsSigningIn] = useState(false)

  const handleLogin = () => {
    setIsSigningIn(true)
    // login() now redirects to Google OAuth
    login()
  }

  return (
    <div className="flex items-center space-x-4">
      <button
        onClick={handleLogin}
        disabled={isLoading || isSigningIn}
        className="btn-primary flex items-center space-x-2"
      >
        {isLoading || isSigningIn ? (
          <>
            <Loader className="w-4 h-4 animate-spin" />
            <span>Signing in...</span>
          </>
        ) : (
          <>
            <LogIn className="w-4 h-4" />
            <span>Sign in with Google</span>
          </>
        )}
      </button>
      
      {error && (
        <div className="text-sm text-error-600 bg-error-50 px-3 py-2 rounded-lg">
          {error}
        </div>
      )}
    </div>
  )
} 